<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import SettingGuide from '../../../SettingGuide.svelte';

	export let device: Device;
	export let title = '';
	export let deferSave = false;
	export let value: boolean | undefined;

	const deviceID = real_id(device.id);
	const component = `input:${device.channel}`;
	const settings = readDeviceSettings(device.id);

	let checked = settings[component].enable;
	let waitingRorRequest = false;

	$: displayed = deferSave && typeof value === 'boolean' ? value : checked;

	const sentRequests = async () => {
		if (deferSave) {
			value = !displayed;
			return;
		}
		checked = !checked;
		if (waitingRorRequest || checked == settings[component].enable) return;
		waitingRorRequest = true;
		const enable = checked;
		const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
			id: device.channel,
			config: { enable },
		});
		if (res.isok) {
			settings[component].enable = checked = enable;
			devices_settings.update_devices_settings(deviceID, settings);
		} else {
			checked = settings[component].enable;
		}
		onSettingsResponse(res, device);
		waitingRorRequest = false;
	};
</script>

<SettingGuide
	{title}
	text={$format('settings_guide_enable_input', {
		default:
			'When this is off, the device ignores the physical switch or button. Use the app or automations to control it instead.',
	})}
/>

<Toggle checked={displayed} size="m" on:click={sentRequests} id="toggle-bxc3eqh">
	{capFirstChar(
		$format('enable', {
			default: 'Enable',
		}),
	)}
</Toggle>
